import { useEffect, useState } from "preact/hooks";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { useMatomo } from "@datapunt/matomo-tracker-react";

import {
  InputAdornment,
  Button,
  TextField,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";

import { AddressAvailableQuery, SignupMutation } from "./UsernamePage.graphql";

import { generateAuthFlowUrl } from "../LoginButton/LoginButton";
import { MarkupText, Text, Localizer } from "preact-i18n";

function validateUsername(input, status) {
  console.log(input, status);
  if (!input) return "";
  if (input.includes("@")) return "Username cannot contain @";
  if (!status) return "Username is taken";
  return "";
}

export const AddressInput = ({ onChange, onValidChange, ...props }) => {
  const [email, setEmail] = useState();
  const [invalidEmail, setInvalidEmail] = useState("");

  const { loading, data } = useQuery(AddressAvailableQuery, {
    variables: { address: email + "@wasc.me" },
    skip: !email,
  });

  useEffect(() => {
    if (loading) return;
    if (!data) return;

    const validity = validateUsername(email, data.addressAvailable.status);
    setInvalidEmail(validity);
    if (onValidChange) onValidChange(validity);
  }, [email, data, loading, setInvalidEmail]);

  return (
    <Localizer>
      <TextField
        id="username-input"
        name="address"
        value={email}
        size="small"
        error={Boolean(invalidEmail)}
        helperText={invalidEmail}
        label={<Text id="Signup.emailInput" />}
        // TODO Change for custom domain feature
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">@wasc.me</InputAdornment>
          ),

          textAlign: "right",
        }}
        aria-describedby="username-helper-text"
        inputProps={{
          "aria-label": "username",
        }}
        onChange={(event) => {
          setEmail(event.target.value);
          onChange(event);
        }}
        {...props}
      />
    </Localizer>
  );
};

export const SignupForm = ({ children, email, ...props }) => {
  const { trackEvent } = useMatomo();

  return (
    <form
      onSubmit={async (event) => {
        event.preventDefault();

        if (!email) return;

        window.localStorage.setItem("signupEmail", email + "@wasc.me");

        trackEvent({
          category: "signup",
          action: "funnel:signup:commitUsername",
        });

        window.location = generateAuthFlowUrl(true, email + "@wasc.me");
      }}
      {...props}
    >
      {children}
    </form>
  );
};

const Signup = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [invalidEmail, setInvalidEmail] = useState("");
  const [interacted, setInteracted] = useState(false);

  const { trackPageView, trackEvent } = useMatomo();

  useEffect(() => {
    trackPageView();
  }, []);

  useEffect(() => {
    // TODO useAccessToken hook
    const { meta } = jwtDecode(localStorage.getItem("accessToken"));

    // if (meta && meta.userId) return navigate("/dashboard");
  }, [navigate]);

  return (
    <div class="w-screen h-screen flex flex-col">
      <div class="bg-blue-400 text-white py-4 shadow grid grid-cols-12 p-2">
        <div class="col-span-12 flex w-full flex items-center justify-between">
          <h1 class="text-lg mr-2 ml-2">Wasc.me Mail</h1>
        </div>
      </div>
      <main class="w-full h-full p-16">
        <SignupForm email={email}>
          <Card className="mt-4">
            <CardContent>
              <h2 class="text-3xl py-4">
                <Text id="Signup.heading" />
              </h2>
              <p class="py-2">
                <MarkupText id="Signup.description" />
              </p>

              <div class="mt-4">
                <AddressInput
                  onChange={(event) => {
                    if (!interacted) {
                      trackEvent({
                        category: "signup",
                        action: "funnel:signup:enteredUsername",
                      });
                      setInteracted(true);
                    }
                    setEmail(event.target.value);
                  }}
                  onValidChange={(invalid) => setInvalidEmail(invalid)}
                />
              </div>
            </CardContent>
            <CardActions>
              <div class="w-full flex justify-end">
                <Button
                  variant="outlined"
                  className=""
                  type="submit"
                  disabled={Boolean(invalidEmail) || !email}
                >
                  <Text id="Signup.signupButton" />
                </Button>
              </div>
            </CardActions>
          </Card>
        </SignupForm>
      </main>
    </div>
  );
};

export default Signup;
